import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { MSG_TYPE_CONFIRM_DELETE_COMMENT, MSG_TYPE_OPENED_MINI_COMMENTER, MSG_TYPE_REMOVE_EMBEDDED_COMMENT } from '../../../constants/IFrameMessageTypes';
export default function useEmbeddedCommentsMessaging(t0) {
  "use memo";

  const $ = _c(20);
  const {
    moduleId,
    broadcastCommentsMessage,
    collaborationSidebarState,
    onClose,
    isOpen
  } = t0;
  const [isMessageHandlerReady, setIsMessageHandlerReady] = useState(false);
  const sendMessageRef = useRef(undefined);
  let t1;
  let t2;
  if ($[0] !== broadcastCommentsMessage || $[1] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        broadcastCommentsMessage({
          type: MSG_TYPE_OPENED_MINI_COMMENTER
        });
      }
    };
    t2 = [broadcastCommentsMessage, isOpen];
    $[0] = broadcastCommentsMessage;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== moduleId || $[5] !== onClose) {
    t3 = message => {
      if (message.type === MSG_TYPE_REMOVE_EMBEDDED_COMMENT && message.payload.moduleId === moduleId && onClose) {
        onClose();
      }
    };
    $[4] = moduleId;
    $[5] = onClose;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleBroadcastMessagesFromSidebar = t3;
  let t4;
  if ($[7] !== collaborationSidebarState.broadcastCommentMessage || $[8] !== handleBroadcastMessagesFromSidebar) {
    t4 = () => {
      if (collaborationSidebarState.broadcastCommentMessage && sendMessageRef.current) {
        const message_0 = collaborationSidebarState.broadcastCommentMessage;
        handleBroadcastMessagesFromSidebar(message_0);
        sendMessageRef.current(message_0.type, message_0);
      }
    };
    $[7] = collaborationSidebarState.broadcastCommentMessage;
    $[8] = handleBroadcastMessagesFromSidebar;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== collaborationSidebarState.broadcastCommentMessage || $[11] !== handleBroadcastMessagesFromSidebar || $[12] !== isMessageHandlerReady) {
    t5 = [collaborationSidebarState.broadcastCommentMessage, handleBroadcastMessagesFromSidebar, isMessageHandlerReady];
    $[10] = collaborationSidebarState.broadcastCommentMessage;
    $[11] = handleBroadcastMessagesFromSidebar;
    $[12] = isMessageHandlerReady;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t4, t5);
  let t6;
  if ($[14] !== broadcastCommentsMessage || $[15] !== collaborationSidebarState.broadcastCommentMessage) {
    t6 = t7 => {
      var _payload;
      const {
        payload
      } = t7;
      if (payload.type === MSG_TYPE_CONFIRM_DELETE_COMMENT && !("broadcast" in payload) && !((_payload = payload.payload) !== null && _payload !== void 0 && _payload.broadcast) && collaborationSidebarState.broadcastCommentMessage) {
        broadcastCommentsMessage(payload);
      }
    };
    $[14] = broadcastCommentsMessage;
    $[15] = collaborationSidebarState.broadcastCommentMessage;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const broadcastDelete = t6;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = t8 => {
      const {
        sendMessage
      } = t8;
      sendMessageRef.current = sendMessage;
      setIsMessageHandlerReady(true);
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleReady = t7;
  let t8;
  if ($[18] !== broadcastDelete) {
    t8 = {
      handleReady,
      broadcastDelete
    };
    $[18] = broadcastDelete;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}